import { MyClubCardsPage } from '@sorare/gameplay/src/pages/my-cards/MyClubCardsPage';

import { PageParams } from './__generated__/routeParams';

const BaseballMyClubCardsPage = () => {
  return <MyClubCardsPage<PageParams> />;
};
export default BaseballMyClubCardsPage;
